var s = Object.defineProperty;
var a = Object.getOwnPropertySymbols;
var o = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
var n = (C, e, t) => e in C ? s(C, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : C[e] = t, c = (C, e) => {
  for (var t in e || (e = {}))
    o.call(e, t) && n(C, t, e[t]);
  if (a)
    for (var t of a(e))
      i.call(e, t) && n(C, t, e[t]);
  return C;
};
var m = (C, e) => {
  var t = {};
  for (var l in C)
    o.call(C, l) && e.indexOf(l) < 0 && (t[l] = C[l]);
  if (C != null && a)
    for (var l of a(C))
      e.indexOf(l) < 0 && i.call(C, l) && (t[l] = C[l]);
  return t;
};
import * as r from "react";
const L = (l) => {
  var V = l, {
    title: C,
    titleId: e
  } = V, t = m(V, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ r.createElement("svg", c({ width: 32, height: 32, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": e }, t), C ? /* @__PURE__ */ r.createElement("title", { id: e }, C) : null, /* @__PURE__ */ r.createElement("path", { d: "M19.7143 1.5C19.0714 1.5 14.5714 2.8125 14.5714 8.71875V13.3125C14.5714 14.7604 15.7246 15.9375 17.1429 15.9375H18.4286V21.1875C18.4286 21.9135 19.0031 22.5 19.7143 22.5C20.4254 22.5 21 21.9135 21 21.1875V15.9375V11.3438V2.8125C21 2.08652 20.4254 1.5 19.7143 1.5ZM5.57143 2.15625C5.57143 1.81992 5.32634 1.54102 4.99688 1.5041C4.66741 1.46719 4.37411 1.68867 4.30179 2.0127L3.08437 7.60313C3.02812 7.86152 3 8.12402 3 8.38652C3 10.2691 4.41027 11.8154 6.21429 11.9836V21.1875C6.21429 21.9135 6.78884 22.5 7.5 22.5C8.21116 22.5 8.78571 21.9135 8.78571 21.1875V11.9836C10.5897 11.8154 12 10.2691 12 8.38652C12 8.12402 11.9719 7.86152 11.9156 7.60313L10.6982 2.0127C10.6259 1.68457 10.3246 1.46719 9.99911 1.5041C9.67366 1.54102 9.42857 1.81992 9.42857 2.15625V7.66055C9.42857 7.88203 9.25179 8.0625 9.03482 8.0625C8.82991 8.0625 8.66116 7.90254 8.64107 7.69336L8.13884 2.09883C8.11071 1.7584 7.83348 1.5 7.5 1.5C7.16652 1.5 6.88929 1.7584 6.86116 2.09883L6.36295 7.69336C6.34286 7.90254 6.17411 8.0625 5.9692 8.0625C5.75223 8.0625 5.57545 7.88203 5.57545 7.66055V2.15625H5.57143ZM7.51205 8.39062H7.5H7.48795L7.5 8.36191L7.51205 8.39062Z" }));
};
export {
  L as default
};
